import { ContractsTabs } from "./ContractsTabs";

export * from "./ContractsTabs";
export default ContractsTabs;
